
import { Alert, Button, Card, Col, DatePicker, Descriptions, Divider, Form, Input, Modal, Row, Select, Statistic, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import { PlusOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from 'file-saver';
import { dateFormat } from '../../Utils/formatDate';
import { formatNumber } from '../../Utils/formatNumber';
import moment from 'moment';
import 'moment/locale/id'; // Tambahkan ini untuk Bahasa Indonesia
import { currencyFormat } from '../../Utils/formatCurrency';
moment.locale('id');


function Membership() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [form] = Form.useForm();
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [outlet, setOutlet] = useState([]);
    const [outletId, setOutletId] = useState([]);
    const [checkOutlet, setCheckOutlet] = useState(false);
    const [isModalPoint, setIsModalPoint] = useState(false);
    const [detailPoint, setDetailPoint] = useState(null);
    const [detailCs, setDetailCs] = useState(null);
    const [summary, setSummary] = useState({});
    const [searchPoint, setSearchPoint] = useState('');
    const [isModalTransDetail, setIsModalTransDetail] = useState(false);
    const [transactionDetail, setTransactionDetail] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    // State baru
    const [filterDate, setFilterDate] = useState(null);



    // //Parameter
    const titlePage = 'Membership';
    const columns = [
        {
            title: 'Nama Customer',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Nomor HP',
            dataIndex: 'phone',
            key: 'phone',
            sorter: true,
        },
        {
            title: 'Tanggal Terdaftar',
            dataIndex: 'created_at',
            key: 'created_at',
            sorter: true,
            render: (text) => dateFormat(text),
        },
        {
            title: 'Total Point',
            dataIndex: 'point',
            key: 'point',
            sorter: true,
            render: (value) => formatNumber(value) + ' point'
        },
        {
            title: 'Total Transaksi',
            dataIndex: 'total_transactions',
            key: 'total_transactions',
            render: (value) => formatNumber(value)
        },
        {
            title: 'Detail',
            key: 'detail',
            render: (_, record) => (
                <Button type="default" onClick={() => pointHistory(record)}>Cek Point</Button>
            )
        }
    ];

    const columnPoint = [
        {
            title: 'Tanggal Transakasi',
            dataIndex: 'date',
            key: 'date',
            render: (text) => <span>{dateFormat(text)}</span>,
        },
        {
            title: 'Kode Transaksi',
            dataIndex: 'transaction_code',
            key: 'transaction_code',
            render: (text) => <b>{text}</b>,
        },
        {
            title: 'Point Diperoleh',
            dataIndex: 'earned',
            key: 'earned',
            align: 'right',
            render: (text) =>
                text > 0 ? (
                    <span style={{ color: '#3f8600', fontWeight: 600 }}>+{formatNumber(text)}</span>
                ) : (
                    '-'
                ),
        },
        {
            title: 'Point Digunakan',
            dataIndex: 'used',
            key: 'used',
            align: 'right',
            render: (text) =>
                text > 0 ? (
                    <span style={{ color: '#cf1322', fontWeight: 600 }}>-{formatNumber(text)}</span>
                ) : (
                    '-'
                ),
        },
        {
            title: 'Point Expired',
            dataIndex: 'expired',
            key: 'expired',
            align: 'right',
            render: (text) =>
                text > 0 ? (
                    <span style={{ color: '#d48806', fontWeight: 600 }}>{formatNumber(text)}</span>
                ) : (
                    '-'
                ),
        },
        {
            title: 'Tanggal Expired',
            dataIndex: 'expired_date',
            key: 'expired_date',
            render: (text) => <span>{moment(text).format('D MMMM YYYY')}</span>,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => {
                return (<Button type="default" onClick={() => showTransactionDetail(record)}>
                    Detail
                </Button>);
            },
        },
    ];

    useEffect(() => {
        if (outlet.length === 0 && checkOutlet === false) {
            getApi('GET', '/outlet?nopage=true', 'outlet');
        }
        var outlet_to_str = '';
        if (outletId.length > 0) {
            outlet_to_str = '&outletId=[' + outletId.toString() + ']';
        }
        let sortParams = '';
        if (page.sortField && page.sortOrder) {
            sortParams = `&sortField=${page.sortField}&sortOrder=${page.sortOrder}`;
        }

        let dateParam = filterDate ? `&date=${filterDate}` : '';
        const url = `/customer?search=${search}${outlet_to_str}${dateParam}&page=${page.pagination.current}${sortParams}`;
        getApi('GET', url, 'customer');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert, outletId]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'customer':
                        var row = [];
                        for (let i = 0; i < res.data.rows.length; i++) {
                            var item = res.data.rows[i];
                            res.data.rows[i].key = item.customer_id
                            row.push({
                                'No': i + 1,
                                'Nama Outlet': item.outlet !== null ? item.outlet.outlet_name : 'Tidak Ada Outlet',
                                'Tanggal Terdaftar': dateFormat(item.created_at),
                                'Nama Customer': item.name,
                                'Nomor HP': item.phone,
                                'Total Point': item.point
                            });
                        }
                        setData(res.data.rows);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.count
                            }
                        });
                        setLoading(false);
                        break;
                    case 'export':
                        exportToExcel(res.data.rows);
                        setLoading(false);
                        break;

                    case 'outlet':
                        var o = [];
                        var o2 = [];
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i] !== null) {
                                o = [...o, {
                                    value: res.data[i].outlet_id,
                                    label: res.data[i].outlet_name
                                }];

                                o2 = [...o2, res.data[i].outlet_id];
                            }
                        }
                        setOutlet(o);
                        setOutletId(o2);
                        setCheckOutlet(true);
                        setLoading(false);
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            } else {
                setLoading(false);
                console.log(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const pointHistory = (customer) => {
        setLoading(true);
        const dataReq = {
            method: 'GET',
            url: `/customerpoint?customerId=${customer.customer_id}`,
            data: {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token') // atau dari redux
                }
            }
        };

        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                setDetailPoint(res.data.list);
                setSummary(res.data.summary);
                setDetailCs(res.data.customer)
                setIsModalPoint(true)
            }
            setLoading(false);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    };

    const showTransactionDetail = (trx) => {
        setLoading(true);
        apiCall({
            method: 'GET',
            url: `/transaction?transcode=${trx.transaction_code}`,
            data: {
                headers: { Authorization: 'Bearer ' + token }
            }
        }).then(res => {
            if (res.status === 200 && res.data.rows.length > 0) {
                setTransactionDetail(res.data.rows[0]);
                setIsModalTransDetail(true);
            }
            setLoading(false);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    }


    const exportToExcel = (customerData) => {
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const periodText = startDate && endDate
            ? `${startDate.format('DD MMM YYYY')} - ${endDate.format('DD MMM YYYY')}`
            : filterDate
                ? moment(filterDate).format('DD MMM YYYY')
                : 'Semua tanggal';
        const selectedOutletNames = outlet
            .filter(item => outletId.includes(item.value))
            .map(item => item.label);
        const outletText = selectedOutletNames.length > 0
            ? selectedOutletNames.join(', ')
            : 'Semua outlet';
        const fileName = `list_membership_${moment().format('YYYYMMDD_HHmm')}`;

        const normalizeGender = (gender) => {
            if (!gender) return '-';
            const value = String(gender).toLowerCase();
            if (['l', 'male', 'pria', 'laki-laki', 'laki laki'].includes(value)) return 'Laki-laki';
            if (['p', 'female', 'wanita', 'perempuan'].includes(value)) return 'Perempuan';
            return gender;
        };

        // Data dibuat selengkap mungkin dari field customer yang dikirim API.
        // Nilai angka tetap numeric agar bisa di-SUM/filter langsung di Excel.
        const apiData = customerData.map((row, index) => ({
            'No': index + 1,
            'Outlet': row.outlet?.outlet_name || 'Tidak Ada Outlet',
            'Kode Member': row.code_customer || '-',
            'Barcode Member': row.barcode_customer || '-',
            'Nama Customer': row.name || '-',
            'Nomor HP': row.phone || '-',
            'Email': row.email || '-',
            'Tanggal Lahir': row.birthday ? dateFormat(row.birthday) : '-',
            'Gender': normalizeGender(row.gender),
            'NIK': row.nik || '-',
            'Alamat': row.address || '-',
            'Tanggal Daftar': row.created_at ? dateFormat(row.created_at) : '-',
            'Update Terakhir': row.updated_at ? dateFormat(row.updated_at) : '-',
            'Total Point': Number(row.point || 0),
            'Total Transaksi': Number(row.total_transactions || 0)
        }));

        const headers = Object.keys(apiData[0] || {
            'No': '', 'Outlet': '', 'Kode Member': '', 'Barcode Member': '',
            'Nama Customer': '', 'Nomor HP': '', 'Email': '', 'Tanggal Lahir': '',
            'Gender': '', 'NIK': '', 'Alamat': '', 'Tanggal Daftar': '',
            'Update Terakhir': '', 'Total Point': '', 'Total Transaksi': ''
        });
        const lastColumn = XLSX.utils.encode_col(headers.length - 1);

        // Row 1-5: title dan informasi filter, row 8: header tabel.
        const ws = XLSX.utils.json_to_sheet(apiData, { origin: 'A8', skipHeader: false });
        XLSX.utils.sheet_add_aoa(ws, [
            ['DATA MEMBERSHIP'],
            [`Periode: ${periodText}`],
            [`Outlet: ${outletText}`],
            [`Total Member: ${customerData.length}`],
            [`Diexport: ${moment().format('DD MMMM YYYY HH:mm')}`]
        ], { origin: 'A1' });

        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
            { s: { r: 2, c: 0 }, e: { r: 2, c: headers.length - 1 } },
            { s: { r: 3, c: 0 }, e: { r: 3, c: headers.length - 1 } },
            { s: { r: 4, c: 0 }, e: { r: 4, c: headers.length - 1 } }
        ];

        const thinBorder = {
            top: { style: 'thin', color: { rgb: 'D9E2F3' } },
            bottom: { style: 'thin', color: { rgb: 'D9E2F3' } },
            left: { style: 'thin', color: { rgb: 'D9E2F3' } },
            right: { style: 'thin', color: { rgb: 'D9E2F3' } }
        };

        // Judul utama dibuat sebagai band penuh sampai kolom terakhir.
        for (let C = 0; C < headers.length; C++) {
            const addr = XLSX.utils.encode_cell({ r: 0, c: C });
            if (!ws[addr]) ws[addr] = { t: 's', v: '' };
            ws[addr].s = {
                font: { bold: true, sz: 18, color: { rgb: 'FFFFFF' } },
                fill: { fgColor: { rgb: '1F4E78' } },
                alignment: { horizontal: 'center', vertical: 'center' }
            };
        }

        // Informasi filter juga diberi warna penuh pada baris merge.
        for (let r = 1; r <= 4; r++) {
            for (let C = 0; C < headers.length; C++) {
                const addr = XLSX.utils.encode_cell({ r, c: C });
                if (!ws[addr]) ws[addr] = { t: 's', v: '' };
                ws[addr].s = {
                    font: { bold: r === 3, color: { rgb: '44546A' } },
                    fill: { fgColor: { rgb: r % 2 === 0 ? 'F7F9FC' : 'EAF2F8' } },
                    alignment: { horizontal: 'left', vertical: 'center' }
                };
            }
        }

        // Header tabel (row Excel 8 / index 7)
        headers.forEach((_, C) => {
            const address = XLSX.utils.encode_cell({ c: C, r: 7 });
            if (!ws[address]) return;
            ws[address].s = {
                font: { bold: true, color: { rgb: 'FFFFFF' } },
                fill: { fgColor: { rgb: '4472C4' } },
                border: thinBorder,
                alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
            };
        });

        // Style baris data + zebra striping.
        for (let R = 8; R < 8 + apiData.length; R++) {
            for (let C = 0; C < headers.length; C++) {
                const address = XLSX.utils.encode_cell({ r: R, c: C });
                if (!ws[address]) continue;
                ws[address].s = {
                    fill: { fgColor: { rgb: R % 2 === 0 ? 'FFFFFF' : 'F6F9FC' } },
                    border: thinBorder,
                    alignment: {
                        vertical: 'top',
                        horizontal: [0, 13, 14].includes(C) ? 'center' : 'left',
                        wrapText: C === 10
                    }
                };
            }
        }

        // Format angka untuk point & transaksi.
        const pointColumnIndex = headers.indexOf('Total Point');
        const trxColumnIndex = headers.indexOf('Total Transaksi');
        [pointColumnIndex, trxColumnIndex].forEach((C) => {
            if (C < 0) return;
            for (let R = 8; R < 8 + apiData.length; R++) {
                const address = XLSX.utils.encode_cell({ r: R, c: C });
                if (ws[address]) {
                    ws[address].z = '#,##0';
                    ws[address].s = {
                        ...ws[address].s,
                        alignment: { horizontal: 'right', vertical: 'top' }
                    };
                }
            }
        });

        // Lebar kolom dibuat manual agar tetap enak dibaca.
        ws['!cols'] = [
            { wch: 6 },  // No
            { wch: 24 }, // Outlet
            { wch: 16 }, // Kode Member
            { wch: 20 }, // Barcode
            { wch: 28 }, // Nama
            { wch: 18 }, // HP
            { wch: 30 }, // Email
            { wch: 17 }, // Tgl Lahir
            { wch: 14 }, // Gender
            { wch: 20 }, // NIK
            { wch: 42 }, // Alamat
            { wch: 18 }, // Daftar
            { wch: 18 }, // Update
            { wch: 15 }, // Point
            { wch: 17 }  // Transaksi
        ];
        ws['!rows'] = [
            { hpt: 28 }, { hpt: 20 }, { hpt: 20 }, { hpt: 20 }, { hpt: 20 },
            { hpt: 8 }, { hpt: 8 }, { hpt: 28 }
        ];
        ws['!autofilter'] = { ref: `A8:${lastColumn}${8 + apiData.length}` };

        // Sheet ringkasan untuk memudahkan membaca konteks export.
        const summaryRows = [
            ['RINGKASAN EXPORT MEMBERSHIP', ''],
            ['Periode', periodText],
            ['Outlet', outletText],
            ['Jumlah Member', customerData.length],
            ['Total Point', customerData.reduce((sum, row) => sum + Number(row.point || 0), 0)],
            ['Total Transaksi', customerData.reduce((sum, row) => sum + Number(row.total_transactions || 0), 0)],
            ['Waktu Export', moment().format('DD MMMM YYYY HH:mm')]
        ];
        const wsSummary = XLSX.utils.aoa_to_sheet(summaryRows);
        wsSummary['!cols'] = [{ wch: 24 }, { wch: 50 }];
        wsSummary['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
        wsSummary['A1'].s = {
            font: { bold: true, sz: 16, color: { rgb: 'FFFFFF' } },
            fill: { fgColor: { rgb: '1F4E78' } },
            alignment: { horizontal: 'center' }
        };
        for (let R = 1; R < summaryRows.length; R++) {
            ['A', 'B'].forEach((col) => {
                const cell = wsSummary[`${col}${R + 1}`];
                if (!cell) return;
                cell.s = {
                    border: thinBorder,
                    fill: { fgColor: { rgb: R % 2 === 0 ? 'F7F9FC' : 'FFFFFF' } },
                    font: { bold: col === 'A' },
                    alignment: { vertical: 'top', wrapText: true }
                };
            });
        }
        wsSummary['B5'].z = '#,##0';
        wsSummary['B6'].z = '#,##0';

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, wsSummary, 'Ringkasan');
        XLSX.utils.book_append_sheet(wb, ws, 'Data Membership');

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, fileName + fileExtension);
    };

    const postApi = (method, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: '/customer',
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        }
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                setdataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const onFinish = (ev) => {
        if (dataModal != null) {
            ev.customer_id = dataModal.customer_id;
            postApi('PUT', ev);
        } else {
            postApi('POST', ev);
        }
    }

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        const order = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : null;
        const sortField = sorter.field || null;

        setPage({
            pagination,
            sortField,
            sortOrder: order,
        });
    };


    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    const handleOk = () => {
        if ((startDate && !endDate) || (!startDate && endDate)) {
            modalError('Start Date dan End Date harus diisi bersamaan.');
            return;
        }

        if (startDate && endDate && startDate.isAfter(endDate, 'day')) {
            modalError('Start Date tidak boleh lebih besar dari End Date.');
            return;
        }

        exportToCSV();
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const exportToCSV = () => {
        var startDates = '';
        var endDates = '';
        var outlet_to_str = '';
        let sortParams = '';
        if (startDate !== null) {
            startDates = '&startDate=' + startDate.format('YYYY-MM-DD');
        }

        if (endDate !== null) {
            endDates = '&endDate=' + endDate.format('YYYY-MM-DD');
        }

        if (outlet.length === 0 && checkOutlet === false) {
            getApi('GET', '/outlet?nopage=true', 'outlet');
        }
        
        if (outletId.length > 0) {
            outlet_to_str = '&outletId=[' + outletId.toString() + ']';
        }

        if (page.sortField && page.sortOrder) {
            sortParams = `&sortField=${page.sortField}&sortOrder=${page.sortOrder}`;
        }

        let dateParam = filterDate ? `&date=${filterDate}` : '';
        const url = `/customer?nopage=true${outlet_to_str}${dateParam}${sortParams}${startDates}${endDates}`;
        getApi('GET', url, 'export');
        setIsModalOpen(false);
    };

    const filteredData = detailPoint?.filter(item =>
        item.transaction_code.toLowerCase().includes(searchPoint.toLowerCase()) ||
        item.date.toLowerCase().includes(searchPoint.toLowerCase()) ||
        item.expired_date?.toLowerCase().includes(searchPoint.toLowerCase())
    );

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Daftar Membership</h3>
            <Row>
                <Col span={4}>
                    <DatePicker
                        format="YYYY-MM-DD"
                        allowClear
                        placeholder="Filter Tanggal Transaksi"
                        onChange={(date, dateString) => {
                            setFilterDate(dateString);
                            setPage({
                                pagination: {
                                    current: 1,
                                    pageSize: 10,
                                },
                            });
                        }}
                        style={{ width: '95%', marginRight: 10 }}
                    />
                </Col>
                <Col span={6}>
                    <Search
                        placeholder="Pencarian Nomor HP"
                        allowClear
                        enterButton="Search"
                        size="medium"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={14} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button style={{ marginBottom: 10, marginRight: 10 }} type="default" onClick={() => setIsModalOpen(true)}>
                        <b style={{ marginLeft: 5 }}>Export Excel</b>
                    </Button>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => setIsModal(true)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Tambah Customer</b>
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Form Membership" open={isModal} onOk={form.submit} onCancel={() => closeModal()} okText="Simpan" >
                <Form form={form} name="form_membership" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="outlet_id"
                        label="Pilih Outlet"
                        rules={[
                            {
                                required: true,
                                message: 'Pilih Outlet kosong!'
                            },
                        ]}
                    >
                        <Select
                            virtual={false}
                            showSearch
                            style={{
                                marginBottom: 10
                            }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            placeholder="Pilih Outlet"
                            options={outlet} />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="Nama Customer"
                        rules={[
                            {
                                required: true,
                                message: 'Nama Customer kosong!'
                            },
                        ]}
                    >
                        <Input placeholder='Nama Customer' />
                    </Form.Item>
                    {
                        dataModal === null &&
                        <Form.Item
                            name="phone"
                            label="Nomor Telepon"
                            rules={[
                                {
                                    required: true,
                                    message: 'Nomor Telepon kosong!'
                                },
                            ]}
                        >
                            <Input placeholder='Nomor Telepon' />
                        </Form.Item>
                    }
                </Form>
            </Modal>

            <Modal
                title="Detail Point Customer"
                open={isModalPoint}
                footer={null}
                onCancel={() => setIsModalPoint(false)}
                width={900}
            >
                {/* Informasi Customer */}
                <Descriptions
                    bordered
                    size="small"
                    column={2}
                    style={{ marginBottom: 24 }}
                    title="Informasi Customer"
                >
                    <Descriptions.Item label="Nama">{detailCs?.name || '-'}</Descriptions.Item>
                    <Descriptions.Item label="Nomor HP">{detailCs?.phone || '-'}</Descriptions.Item>
                </Descriptions>

                <Divider orientation="left">Ringkasan Point</Divider>

                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12} lg={6}>
                        <Card>
                            <Statistic
                                title="Total Poin Diperoleh"
                                value={summary.earned}
                                valueStyle={{ color: "#3f8600" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6}>
                        <Card>
                            <Statistic
                                title="Poin Digunakan"
                                value={summary.used}
                                valueStyle={{ color: "#cf1322" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6}>
                        <Card>
                            <Statistic
                                title="Poin Expired"
                                value={summary.expired}
                                valueStyle={{ color: "#d46b08" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={6}>
                        <Card>
                            <Statistic
                                title="Sisa Poin Aktif"
                                value={summary.remaining}
                                valueStyle={{ color: "#1890ff" }}
                            />
                        </Card>
                    </Col>
                </Row>

                <Divider orientation="left">Riwayat Point</Divider>

                <Input.Search
                    placeholder="Cari Kode Transaksi atau Tanggal"
                    allowClear
                    onChange={(e) => setSearchPoint(e.target.value)}
                    style={{ marginBottom: 16, width: '40%' }}
                />

                <Table
                    columns={columnPoint}
                    dataSource={filteredData}
                    loading={loading}
                    rowKey="transaction_code"
                    pagination={{ pageSize: 10 }}
                    size="middle"
                    bordered
                    style={{ marginBottom: 24 }}
                />
            </Modal>

            <Modal
                title="Detail Transaksi"
                open={isModalTransDetail}
                onCancel={() => setIsModalTransDetail(false)}
                footer={null}
                width={800}
            >
                {transactionDetail ? (
                    <>
                        <Descriptions bordered column={2} title="Informasi Transaksi">
                            <Descriptions.Item label="Kode Transaksi">{transactionDetail.transaction_code}</Descriptions.Item>
                            <Descriptions.Item label="Tanggal">{dateFormat(transactionDetail.created_at)}</Descriptions.Item>
                            <Descriptions.Item label="Nama Customer">{transactionDetail.customer?.name}</Descriptions.Item>
                            <Descriptions.Item label="No HP">{transactionDetail.customer?.phone}</Descriptions.Item>
                            <Descriptions.Item label="Outlet">{transactionDetail.outlet?.outlet_name}</Descriptions.Item>
                            <Descriptions.Item label="Total Pembayaran">{currencyFormat(transactionDetail.grand_total)}</Descriptions.Item>
                            <Descriptions.Item label="Poin Diperoleh">{formatNumber(transactionDetail.point?.point)}</Descriptions.Item>
                            <Descriptions.Item label="Poin Digunakan">{formatNumber(transactionDetail.point_redeem)}</Descriptions.Item>
                        </Descriptions>

                        <Divider orientation="left">Produk</Divider>
                        <Table
                            size="small"
                            columns={[
                                {
                                    title: "Nama Produk",
                                    dataIndex: "product",
                                    key: "product",
                                    render: (val) => val?.product_name
                                },
                                {
                                    title: "Qty",
                                    dataIndex: "qty",
                                    key: "qty"
                                },
                                {
                                    title: "Harga",
                                    dataIndex: "price",
                                    key: "price",
                                    render: (val) => formatNumber(val)
                                },
                                {
                                    title: "Subtotal",
                                    dataIndex: "subtotal",
                                    key: "subtotal",
                                    render: (val) => formatNumber(val)
                                },
                            ]}
                            dataSource={transactionDetail.transaction_products}
                            rowKey="transaction_product_id"
                            pagination={false}
                            bordered
                        />
                    </>
                ) : (
                    <p>Loading...</p>
                )}
            </Modal>

            <Modal
                title="Pilih Rentang Tanggal"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Export"
                cancelText="Batal"
            >
                <div style={{ marginBottom: 16 }}>
                    <label>Start Date:</label>
                    <DatePicker
                        style={{ width: '100%' }}
                        onChange={(date) => setStartDate(date)}
                        value={startDate}
                    />
                </div>
                <div>
                    <label>End Date:</label>
                    <DatePicker
                        style={{ width: '100%' }}
                        onChange={(date) => setEndDate(date)}
                        value={endDate}
                    />
                </div>
            </Modal>
        </>
    );
}

export default Membership;